import EditorContainer from './EditorContainer';

export default EditorContainer;
